import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import * as app_consts from "../../../../utils/app_consts";
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { useDispatch, useSelector } from 'react-redux';
import { RETRIEVE_TENANT_PRODUCT_CATEGORY_STOCK_AGE_ANALYSIS_DATA_API } from '../../../../api/api_data';
import {
  fail_retrieve_tenant_stock_age_analysis_brand_analysis_data,
  loading_retrieve_tenant_stock_age_analysis_brand_analysis_data,
  reset_retrieve_tenant_stock_age_analysis_brand_analysis_data,
  success_retrieve_tenant_stock_age_analysis_brand_analysis_data
} from '../../../../reducers/auth_tenant/retrieve_tenant_stock_age_analysis_brand_analysis_data_Slice';
import {
  COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_ERROR_MSG,
  COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_SUCCESS_MSG
} from '../../../../utils/error_success_messages';
import { formatNumber, messageToast } from '../../../../utils/Utils';
import { Button, Col, Icon, Row } from '../../../../components/Component';
import { Card } from 'reactstrap';
import ViewBrandStockAgeAnalysisModal from '../../../../components/modal/inventory/ViewBrandStockAgeAnalysisModal';
import moment from 'moment';
import { download, generateCsv, mkConfig } from 'export-to-csv';

const StockAgeAnalysisReportsSummary = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const dispatch = useDispatch();
  const [view_category_data_modal, setViewCategoryDataModal] = useState();
  const [selected_category, setSelectedCategory] = useState();
  const [sm, updateSm] = useState(false);

  const open_view_category_data_modal = (category) => {
    setViewCategoryDataModal(true);
    setSelectedCategory(category);
  };

  const close_view_category_data_modal = () => {
    setViewCategoryDataModal(false);
    setSelectedCategory('');
  };

  const view_category_data_modal_successFunction = () => {
    retrieve_data();
  };

  useEffect(() => {
    retrieve_data();
  }, []);

  const retrieve_data = () => {
    setError("");

    dispatch(tenant_auth_actions_helper(
      loading_retrieve_tenant_stock_age_analysis_brand_analysis_data,
      success_retrieve_tenant_stock_age_analysis_brand_analysis_data,
      fail_retrieve_tenant_stock_age_analysis_brand_analysis_data,
      COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_ERROR_MSG,
      COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_SUCCESS_MSG,
      app_consts.GET,
      `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCT_CATEGORY_STOCK_AGE_ANALYSIS_DATA_API}`
    ));
  };

  const listener = useSelector((state) =>
    state.retrieve_tenant_stock_age_analysis_brand_analysis_data
      .retrieve_tenant_stock_age_analysis_brand_analysis_data
  );

  useEffect(() => {
    if (listener?.status !== app_consts.IDLE)
    {
      if (listener?.status === app_consts.LOADING && !page_data)
      {
        setLoading(true);
      } else
      {
        if (listener?.status === app_consts.FAIL && !page_data)
        {
          messageToast(listener.message, app_consts.FAIL);
          setError(listener?.message);
        }

        if (listener?.status === app_consts.SUCCESS)
        {
          setPageData(listener?.data || []);
        }

        dispatch(reset_retrieve_tenant_stock_age_analysis_brand_analysis_data());
        setLoading(false);
      }
    }
  }, [listener]);

  // ✅ Clean Card
  const CustomStatCard = ({ name, value }) => {
    return (
      <div style={{
        background: "#fff",
        borderRadius: "10px",
        padding: "16px",
        border: "1px solid #e5e7eb",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}>
        {/* Content */}
        <div>
          <div style={{
            fontWeight: "600",
            fontSize: "15px",
            marginBottom: "8px"
          }}>
            {name?.replace(/_/g, " ").toUpperCase() || "--"}
          </div>

          <div style={{
            fontSize: "20px",
            fontWeight: "700"
          }}>
            {value || "--"}
          </div>
        </div>

        {/* Button */}
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "16px"
        }}>
          <Button
            size="sm"
            color="primary"
            onClick={() => open_view_category_data_modal(name)}
          >
            View
          </Button>
        </div>
      </div>
    );
  };

  const export_to_csv = async (e) => {
    e.preventDefault();
    const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

    // Headers
    const csv_headers = ["Category", "Average Age Days"];

    const csv_data = page_data?.average_stock_age_by_category?.map((item) => {
      return {
        rank: item?.category,
        average_age_days: formatNumber(item?.average_age_days)
      };
    });

    const options = mkConfig({
      fieldSeparator: ',',
      quoteStrings: '"',
      showLabels: true,
      showTitle: false,
      title: " ",
      useTextFile: false,
      useBom: true,
      filename: `Stock Age by Category on ${cur_dt}`,
      useKeysAsHeaders: true,
      columnHeaders: csv_headers,
    });

    const csv = generateCsv(options)(csv_data || []);

    download(options)(csv);

  };

  return (
    <div style={{ paddingBottom: "30px" }}>
      {
        loading ? (
          <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading..." />
        ) : error ? (
          <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
        ) : (
          <>
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="mb-3 p-3 bg-light rounded border">
                <small className="text-muted">
                  This report shows average stock age (in days) per category.
                </small>
              </div>
            </motion.div>

            <Row>
              <Col md="12">
                <Card className="p-3">
                  <div
                    className="d-flex justify-content-between align-items-center my-4"
                    style={{ width: "100%" }}
                  >
                    <h6 className="mb-0">Stock Age by Category</h6>

                    <Button color="primary" className="btn-primary" onClick={export_to_csv}>
                      <Icon name="download-cloud" />
                      <span>Export to CSV</span>
                    </Button>
                  </div>

                  {/* ✅ GRID */}
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                    gap: "16px"
                  }}>

                    {
                      page_data?.average_stock_age_by_category?.length > 0 ? (
                        page_data?.average_stock_age_by_category.map((item, index) => (
                          <CustomStatCard
                            key={index}
                            name={item.category}
                            value={`${formatNumber(item.average_age_days || 0)} Days`}
                          />
                        ))
                      ) : (
                        <div>No data available</div>
                      )
                    }

                  </div>
                </Card>
              </Col>
            </Row>

            <ViewBrandStockAgeAnalysisModal tenant_info={tenant_info} user_info={user_info} isOpen={view_category_data_modal} successFunction={view_category_data_modal_successFunction} closeModal={close_view_category_data_modal} data={selected_category} />
          </>
        )
      }
    </div>
  );
};

export default StockAgeAnalysisReportsSummary;